const initFooterMenu = () => {
	if (window.innerWidth > 992) {
		return;
	}

	Array.from(document.querySelectorAll('.nav-block > .title'))
		.forEach((title) => {
			title.addEventListener('click', (e) => {
				const titleClassList = e.target.parentNode.classList;

				if (titleClassList.contains('-active')) {
					titleClassList.remove('-active');
					return;
				}

				titleClassList.add('-active');
			});
		});
};

export default initFooterMenu;



// WEBPACK FOOTER //
// ./src/js/common/initFooterMenu.js